import tippy from 'tippy.js';

export default {

    init() {
		document.addEventListener("DOMContentLoaded", this.bindEvents);
    },

    bindEvents() {
        $('[data-tooltip]').each(function(index, elem){
			let message = elem.dataset.message;

			if(!message) {
				return;
			}

			tippy(elem, {
				content: message,
				theme: 'light',
				placement: 'bottom',
				interactive: true,
			});
		});
    },

};